import { getLoginStatus } from 'src/components/LoginStatusIndicator';

export type AccountStatusFilter = 'all' | 'active' | 'invited';

type AccountLoginHistory = {
    hasEverLoggedIn?: boolean;
    lastLoggedInAt?: string;
};

export const matchesAccountStatus = (
    account: AccountLoginHistory,
    filter: AccountStatusFilter,
): boolean =>
    filter === 'all' ||
    getLoginStatus(account) ===
        (filter === 'active' ? 'logged-in' : 'never-logged-in');

export const matchesMainContactStatus = (
    contacts: AccountLoginHistory[],
    filter: AccountStatusFilter,
): boolean => {
    if (filter === 'all') return true;
    if (filter === 'active') {
        return contacts.some(contact => matchesAccountStatus(contact, filter));
    }
    return (
        contacts.length > 0 &&
        contacts.every(contact => matchesAccountStatus(contact, filter))
    );
};
